let region;

/**
 * Announce a message to screen reader users via a shared, visually hidden live region.
 */
export function announce(message, politeness = 'polite') {
    if (!region) {
        region = document.createElement('div');
        region.className = 'mellow-sr-only';
        region.setAttribute('aria-live', politeness);
        region.setAttribute('aria-atomic', 'true');
        document.body.append(region);
    }

    region.setAttribute('aria-live', politeness);
    region.textContent = '';
    // Changing the text in a new frame makes repeated identical messages announce again.
    requestAnimationFrame(() => (region.textContent = message));
}
